var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"breadcrumb",attrs:{"aria-label":"Breadcrumb"}},[_c('a',{attrs:{"href":"/"}},[_vm._v("Home")]),_vm._v(" "),_c('span',[_vm._v("/")]),_vm._v(" "),_c('a',{attrs:{"href":"/blog/"}},[_vm._v("Blog")]),_vm._v(" "),_c('span',[_vm._v("/")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.currentTitle))])])
}
var staticRenderFns = []

export { render, staticRenderFns }